/**
 * Persist filter cho /matching/match-instruct qua generic registry
 * `user_preferences` (skill /user-logaction).
 *
 * 1 scope `matching-ps` + 1 key `page_filter`, nested theo context (sub-key):
 *   - main-p / main-s        : 2 cột màn hình chính (MatchInstructTab)
 *   - direct-p / direct-s / direct-detail : Direct P-S dialog
 *   - stock-p / stock-s      : candidate filter của P/S-Instruction dialog
 *   - stock-factory          : filter TLC Factory (grade + factory) — DÙNG CHUNG
 *                              cho cả 2 dialog P/S (mirror Access module match_factory)
 *   - data-plan              : Data Plan dialog
 *
 * Baseline (BE): dates = null, category = ''. FE coi `dateFrom/dateTo == null`
 * ⇒ dùng default fiscal-year ĐỘNG → không freeze 1 năm cứng. Chỉ patch khi user
 * tự đổi control (per-field) nên user row chỉ chứa delta thật.
 *
 * Per-column filter ▽ trong header KHÔNG persist (session-only — Q1 chốt).
 */
import { usePreference } from '@/hooks/usePreference'

export const MATCHING_PREF_SCOPE = 'matching-ps'
export const MATCHING_PREF_KEY = 'page_filter'

/** Context sub-keys — phải MATCH baseline Python `matching_ps_page_filter.py`. */
export type MatchingFilterContext =
  | 'main-p'
  | 'main-s'
  | 'direct-p'
  | 'direct-s'
  | 'direct-detail'
  | 'stock-p'
  | 'stock-s'
  | 'stock-factory'
  | 'data-plan'
  | 'stock-sales'

/** Shape filter page-level chung (Grade + date range). */
export interface MatchingFilterCtx extends Record<string, unknown> {
  category: string
  dateFrom: string | null
  dateTo: string | null
}

/** TLC Factory filter của P/S-Instruction dialog (grade + factory_code). */
export interface StockFactoryFilterCtx extends MatchingFilterCtx {
  factoryCode: string
}

/** Data Plan thêm mode + cbFilter (mirror Access btnDirect/btnPStock/btnSStock). */
export interface DataPlanFilterCtx extends MatchingFilterCtx {
  mode: string
  filter: string
}

/** usePreference bound sẵn scope/key của Match-Instruct cho 1 context. */
export function useMatchingFilterPref<T extends MatchingFilterCtx>(context: MatchingFilterContext) {
  return usePreference<T>(MATCHING_PREF_SCOPE, MATCHING_PREF_KEY, context)
}
